<template>
	<div class="flex-row dropdown" v-if="dropdownList.length">
		<el-dropdown @command="handleCommand" v-if="dropdownList.length === 2">
			<div class="view_border flex-row-align-center">
				<div class="flex-row-align-center font-h6-regular yx-color-g-9 cursor-pointer view">
					<span class="ml-4 fz-14 color-gy-9">{{ name }}</span>
					<i class="el-icon-arrow-down el-icon--right"></i>
				</div>
				<div class="home_header_line"></div>
			</div>

			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item :command="item.value" class="pt-4 pb-4 pl-24 pr-24" v-for="(item, index) in dropdownList" :key="index">
					{{ item.label }}
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<div class="el-dropdown">
			<div
				:style="{ borderColor: borderColor }"
				v-if="dropdownList.length === 1"
				class="view_border yx-border-top yx-border-bottom yx-border-left flex-row-align-center view font-h6-regular yx-color-g-9 cursor-pointer"
			>
				<span class="ml-4 fz-14">{{ name }}</span>
			</div>
		</div>

		<dr-partner-select
			style="width: 250px"
			v-model="userIdsArr"
			class="select"
			placeholder="请输入/选择"
			@input="change"
			:collapseTags="true"
			:apiType="1"
			:multiple="true"
			v-if="type"
			size="small"
			ref="drPartnerSelect"
		/>
		<dept-tree-select
			style="width: 250px"
			v-model="deptIdsArr"
			class="select"
			v-else
			:collapseTags="true"
			:returnArray="true"
			@input="change"
			@change="deptChange"
			ref="deptTreeSelect"
			size="small"
		/>
	</div>
</template>
<script>
import drPartnerSelect from '@/components/drPartnerSelect';
import deptTreeSelect from '@/components/business/deptTreeSelect/deptTreeSelect';
import { mapGetters } from 'vuex';
const SEARCH_DEPT = {
	label: '部门',
	value: 0,
};
const SEARCH_USER = {
	label: '员工',
	value: 1,
};
export default {
	components: {
		drPartnerSelect,
		deptTreeSelect,
	},
	props: {
		userIds: {
			type: Array,
		},
		deptIds: {
			type: Array,
		},
	},
	data() {
		return {
			name: '搜部门',
			type: 0,
			borderColor: '#e2e3e8',
			userIdsArr: [],
			deptIdsArr: [],
		};
	},
	watch: {
		userIds: {
			handler(val) {
				this.userIdsArr = val;
			},
			deep: true,
			immediate: true,
		},
		deptIds: {
			handler(val) {
				this.deptIdsArr = val;
			},
			deep: true,
			immediate: true,
		},
	},
	computed: {
		...mapGetters(['showDeptSelect', 'hasDeptDataScope', 'hasUserTag', 'isNotShopOrDrDataView']),
		dropdownList({ showDeptSelect, hasDeptDataScope, isNotShopOrDrDataView, hasUserTag, deptIds }) {
			let obj1 = {
				...SEARCH_DEPT,
				isShow: showDeptSelect && isNotShopOrDrDataView,
			};
			let obj2 = {
				...SEARCH_USER,
				isShow: (hasDeptDataScope || hasUserTag) && isNotShopOrDrDataView,
			};
			let arr = [];
			arr = [obj2, obj1];
			if (deptIds?.length) arr = [obj1, obj2];
			return arr.filter(item => item.isShow);
		},
	},
	mounted() {
		this.init();
	},
	methods: {
		handleCommand(e) {
			this.type = e;
			this.name = this.dropdownList.find(item => item.value === e).label;
			this.$emit('changeType', this.type);
		},
		change(value, name) {
			this.$emit('change', value, this.type, name);
		},
		init(initValue) {
			if (initValue) {
				const { label, value } = initValue;
				this.name = label;
				this.type = value;
				return;
			}
			if (this.userIds?.length) {
				this.name = SEARCH_USER.label;
				this.type = SEARCH_USER.value;
				return;
			}
			if (this.deptIds?.length) {
				this.name = SEARCH_DEPT.label;
				this.type = SEARCH_DEPT.value;
				return;
			}
			if (this.dropdownList.length) {
				const [{ label, value }] = this.dropdownList;
				this.name = label;
				this.type = value;
				return;
			}
			this.name = SEARCH_DEPT.label;
			this.type = SEARCH_DEPT.value;
		},
		reset() {
			this.$refs['deptTreeSelect']?.reset();
			this.$refs['drPartnerSelect']?.reset();
			if (this.dropdownList.length) {
				const [{ label, value }] = this.dropdownList;
				this.name = label;
				this.type = value;
				return;
			}
			this.name = SEARCH_DEPT.label;
			this.type = SEARCH_DEPT.value;
		},
		deptChange(str, val) {
			this.deptIdsArr = val;
		},
	},
};
</script>
<style lang="less" scoped>
.view_border {
	height: 100%;
	box-sizing: border-box;
}
.view {
	padding: 0px 10px;
	opacity: 0.9;
}
.dropdown {
	align-items: stretch;
	.el-dropdown {
		min-height: 100%;
	}
	/deep/ .el-tag--light {
		max-width: 100px !important;
	}
	&:hover {
		/deep/.el-input__inner {
			border-color: #2475ff;
		}
	}
}
.home_header_line {
	height: 10px;
	background: #f0f1f5;
	width: 1px;
}
/deep/ .el-cascader {
	line-height: 31px;
}
</style>
